import React, { useEffect, useState } from 'react';
import { TextField, Button, Container, Typography, Alert, Box, Modal, TextareaAutosize, ButtonGroup, IconButton, CircularProgress, Select, MenuItem, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { req, reqPoll } from './ServerUtils';
import ImagesUploader from './ImagesUploader';
import { useParams } from 'react-router-dom';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import InspirationUploader from './InspirationUploader';
import { SetDesigner, SetDesignerWidget } from './SetDesigner';
import HtmlEditor from './HtmlEditor';
import DesignEditor from './DesignEditor';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Delete } from '@mui/icons-material';
import { useUser } from './UserProvider';
import SampleResponse from './SampleResponse';

// const svgIcon = `<svg viewBox="0 0 256 256" height="256" width="256"><circle r="128" cx="128" cy="128" fill="limegreen" /></svg>`
const imgSrc = 'https://placehold.co/600x400/EEE/31343C';
const svgIcon = `<svg version="1.1" width="256" height="256" viewBox="0 0 256 256"><path d="M0 0 C0.8778515625000125 0.38414062500000057 1.7557031249999966 0.7682812499999994 2.66015625 1.1640625 C19.772241740175588 9.379879686741155 32.382275441549154 25.56094692699655 39.00390625 43.04296875 C39.332617187500006 44.0187890625 39.66132812500001 44.994609375 40 46 C40.31839843750001 46.9448828125 40.63679687499999 47.889765625 40.96484375 48.86328125 C46.53186797553724 68.64289266884441 43.47424079922686 89.78158480318231 33.94140625 107.71484375 C30.986847759462762 112.71440851970185 27.863749711051355 117.64773021053986 24 122 C23.340000000000003 122 22.680000000000007 122 22 122 C21.78859374999999 122.56074218750001 21.577187500000008 123.121484375 21.359375 123.69921875 C19.539309970189265 126.7797311136739 17.05950352928818 128.68507485430752 14.25 130.8125 C13.674353027343756 131.2490087890625 13.098706054687511 131.685517578125 12.505615234375 132.13525390625 C-4.39807191590188 144.57713527135448 -24.201752733123612 149.86211863922767 -44.9375 147.125 C-47.2936267353092 146.76251896379858 -49.64807203161266 146.3887936804552 -52 146 C-57.297801235108636 145.17573106667334 -61.01055847408114 144.76788142261526 -66 147 C-72.1757637047044 147.8822519578149 -76.71299795398755 145.67745535064233 -82.23046875 143.19140625 C-84.52422473297618 142.20467060147004 -86.53275913145102 141.35483913615087 -89 141 C-90.64594139430292 142.39588753920356 -90.64594139430292 142.39588753920356 -92 144 C-92.66 144 -93.32 144 -94 144 C-93.87818359375 145.2684375 -93.87818359375 145.2684375 -93.75390625 146.5625 C-93.17344516748454 156.98710719619618 -93.17344516748454 156.98710719619618 -96.8125 161.25 C-98.16423661350902 162.5475587933283 -99.5648839266202 163.79530395934435 -101 165 C-102.21623046875 166.03833984375 -102.21623046875 166.03833984375 -103.45703125 167.09765625 C-105.28096760671498 168.61181717863454 -107.12177472849302 170.10582344829376 -108.9765625 171.58203125 C-112.20389717844871 174.16306505614955 -115.35578420118206 176.81911293851343 -118.5 179.5 C-122.52453560260209 182.92408889320606 -126.58028923250126 186.29983923759622 -130.6875 189.625 C-134.2153692321403 192.49426556941077 -137.63719922415237 195.43905693159067 -141 198.5 C-148.6393190001741 205.44814251920596 -156.6632136949187 211.90865184012685 -165 218 C-165.02578125 217.29875 -165.0515625 216.5975 -165.078125 215.875 C-165.66991268701997 205.97600596257521 -168.72511460431167 198.85718862655787 -176 192 C-180.39942378003175 188.65481601979153 -184.5854380354044 187.44200505833433 -190 187 C-187.80231371031806 188.69052791513994 -185.64129184147447 190.21196391185597 -183.25 191.625 C-176.06073462488308 196.42392587222272 -170.39003128946177 203.68324372106366 -168 212 C-167.4539089918656 215.33255538297408 -167.1408321625345 218.62706970729838 -167 222 C-170.8447880817633 224.97661012781677 -173.9511333609132 225.53914823280837 -178.671875 225.3359375 C-186.05419932611565 224.2707027818021 -190.65637711392134 219.94882775867626 -195.30078125 214.35546875 C-199.7864407084041 208.13741667317777 -201.1142752065925 201.60781003121778 -200 194 C-197.7923357308324 189.21672741680354 -194.6101562552539 186.76919663746924 -190.4375 183.80078125 C-187.53641641987187 181.65751277173226 -184.80040183661418 179.34462131607364 -182.0625 177 C-176.94328657049994 172.62809491393168 -171.76984358698908 168.32901854472286 -166.5625 164.0625 C-161.19790884091782 159.6628022669998 -155.87940254854396 155.2182641578518 -150.625 150.6875 C-145.67674450808775 146.4210879868547 -140.6844086325723 142.2205405179463 -135.60546875 138.109375 C-133.80642017905092 136.6528739080772 -132.017948921377 135.18324464748187 -130.23828125 133.703125 C-129.3552734375 132.97609375 -128.472265625 132.2490625 -127.5625 131.5 C-126.7800390625 130.8503125 -125.997578125 130.200625 -125.19140625 129.53125 C-122.1370988389951 127.39704589106253 -120.2590578357089 126.84261777053638 -116.5625 127.3046875 C-115.2940625 127.58699218750002 -115.2940625 127.58699218750002 -114 127.875 C-112.7315625 128.1495703125 -112.7315625 128.1495703125 -111.4375 128.4296875 C-109.2860497397483 128.9330716955076 -107.14119470414109 129.45478838551963 -105 130 C-104.67 129.34 -104.34 128.68 -104 128 C-103.34 128 -102.68 128 -102 128 C-102.5053125 127.11699218749999 -103.010625 126.233984375 -103.53125 125.32421875 C-107.55996558681957 117.99583231604747 -110.72336755969069 111.61683779845346 -109 103 C-108.01 101.515 -108.01 101.515 -107 100 C-107.38965184486986 96.05477507069268 -108.42074064198687 92.36688923699627 -109.5 88.5625 C-114.6312801018576 68.08793407633175 -111.3610595857012 47.05660783182823 -100.5625 29 C-88.66649352647806 9.891721413429824 -70.6093697433007 -1.6719755024454335 -49 -7 C-31.947183342811257 -9.958333939423905 -15.560706792011246 -7.467412690757125 0 0 Z M-73.965087890625 30.509521484375 C-85.42856883325541 42.215847482570766 -89.52554772368094 56.45950317210708 -89.420166015625 72.51611328125 C-89.00054057402917 86.79946617186297 -83.54334522974214 99.52391719478918 -73.625 109.875 C-62.291340960848174 120.42768421460522 -48.31627816779786 126.47753024094894 -32.640625 126.2109375 C-18.1198864410415 125.05099684588203 -4.044853900212871 119.53427466980759 6.0546875 108.8203125 C17.106877955988352 95.76621584820998 22.107456282743442 81.02201323476007 21 64 C18.850032331606684 48.877346061301225 11.983417358407394 35.03255169592447 -0.3125 25.75 C-24.012235570989787 9.43001748060787 -52.80942929789015 10.517230219685882 -73.965087890625 30.509521484375 Z " fill="currentColor" transform="translate(210,9)"></path><path d="M0 0 C12.52790433444818 -0.5811914381960506 22.07037541922358 1.540659976909211 31.875 9.52734375 C38.26861077059988 15.383560511864118 42.38827361496189 22.760559164411497 42.953125 31.484375 C43.04952600851976 36.65789579056093 43.071971753328256 41.826030621847025 43 47 C40.39970961580144 44.399709615801456 40.011390888034214 42.07670208163165 38.9375 38.5625 C33.81203261940345 23.256929653105352 19.05851507035925 10.061614910144804 4.81640625 2.90234375 C3.2321315607113377 2.216993532299675 1.6191293629049994 1.5983738949866222 0 1 C0 0.6700000000000017 0 0.3400000000000034 0 0 Z " fill="currentColor" transform="translate(178,33)"></path></svg>`;

const presets = [{
  name: 'Portrait',
  width: 600,
  height: 1200,
  icon: <CropPortraitIcon />
}, {
  name: 'Landscape',
  width: 800,
  height: 1200,
  icon: <CropLandscapeIcon />
}, {
  name: 'Square',
  width: 1080,
  height: 1080,
  icon: <CropSquareIcon />
  
}]

function findHardcodedColors(htmlCode) {
  if (!htmlCode) return [];
  // Remove :root { ... } block
  htmlCode = htmlCode.replace(/:root\s*\{[^}]*\}/g, '');

  // Match hex, rgb(), and rgba() colors
  const colorRegex = /#(?:[0-9a-fA-F]{3}){1,2}\b|rgb(?:a)?\(\s*\d+\s*,\s*\d+\s*,\s*\d+(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)/g;
  const matches = htmlCode.match(colorRegex) || [];

  // Print matched colors
  return matches;
}


const TemplateEditor = () => {
  const {templateId} = useParams();
  const [id, setId] = useState(templateId);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [modalData, setModalData] = useState({
    sectionHeader: {
      title: 'Catchy Infographic header',
      subtitle: 'Subtitle to go with the header',
      body: 'This is an insightful, detailed body of the section that is interesting, fun and informative.',
    },
    blocks: Array(10).fill(0).map((_, index) => ({
      title: `Title of ${index + 1} block`,
      subtitle: `Subtitle of ${index + 1} block`,
      body: `This is an insightful, detailed body of the ${index + 1} block that is interesting, fun and informative.`
    })),
    footer: {
      title: 'Footer Title',
      subtitle: 'Footer Subtitle',
      body: 'Footer Body'
    }
  });

  const {userInfo} = useUser();

  const [loading, setLoading] = useState(false);
  const [templateImages, setTemplateImages] = useState([]);
  const [preset, setPreset] = useState(presets[0]);
  
  const [template, setTemplateInt] = useState(null);
  const [subject, setSubject] = useState('');
  const [currentPage, setCurrentPage] = useState(0);

  const [activeTab, setActiveTab] = useState('html');

  const [numItems, setNumItems] = useState(6);
  const [forceFetch, setForceFetch] = useState(false);

  function setTemplate(t) {
    setTemplateInt(t);
  }


  useEffect(() => {
    setLoading(true);
    if (userInfo) {    
      req(`/designer/html_template?id=${templateId}`)
        .then((res) => {
          setLoading(false);
          if (res.error) {
            console.error(res.error);
          } else {
            res.previews = res.previews.map(url => url + "?t=" + Date.now());
            setTemplate(res);
            setTemplateImages(res.images);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    }
  }, [userInfo]);

  const handleModalChange = (section, field, value, index = null) => {
    setModalData((prev) => {
      const updated = { ...prev };
      if (index !== null) {
        updated[section][index][field] = value;
      } else {
        updated[section][field] = value;
      }
      return updated;
    });
  };

  const generateSample = async (e) => {
    e.preventDefault();
    
    setLoading(true);
    setError(null);

    let width = 600, height = 0;
      if (template.category == "carousel")  {
        width = 800;
        height = 800;
      } else if (template.category == "linkedin-banner") {
        width = 1584;
        height = 396;
      }
    
    req('/designer/html_templates', 'PUT', JSON.stringify({
        id,
        title: template.title,
        pages: template.pages,
        width,
        height,
        styles: template.styles,
        data_template: template.data_template,
        data_template_json: template.data_template_json,
        sample_response: template.sample_response
    })).then(res => {        
        return reqPoll('/generate-sample', 'POST', JSON.stringify({
            template_id: id,
            subject: subject || template.title,
            num_blocks: parseInt(numItems),
            force_fetch: forceFetch,
            width,
            height
        }))
    }).then(res => {
        setLoading(false);
        window.open(res.url, '_blank');
        // window.open('/design/' + res.design_id, '_blank');
    }).catch(error => {
        setLoading(false);
        console.error(error);
        setError('Error generating sample: ' + error.message);
    });
  };

return (
  <div style={{ flex: 1, textAlign: 'center' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
      <ToggleButtonGroup
        size="small"
        value={activeTab}
        exclusive
        onChange={(e, v) => setActiveTab(v)}
        fullWidth
        sx={{  }}
      >
        <ToggleButton color="secondary" value="html" sx={{ textTransform: 'none' }}>
        HTML
        </ToggleButton>
       
        <ToggleButton color="secondary" value="sample" sx={{ textTransform: 'none' }}>
          Generated Sample
        </ToggleButton>
        
        <ToggleButton color="secondary" value="sample-response" sx={{ textTransform: 'none' }}>
          Sample Response
        </ToggleButton>
       
        <ToggleButton color="secondary" value="inspiration" sx={{ textTransform: 'none' }}>
        Inspiration
        </ToggleButton>
      </ToggleButtonGroup>
      
    </div>

    <>
      {activeTab === 'html' && <Html template={template} setTemplate={setTemplate}
       currentPage={currentPage} setCurrentPage={setCurrentPage} id={id} templateImages={templateImages} setTemplateImages={setTemplateImages} generateSample={generateSample} loading={loading} error={error} numItems={numItems} forceFetch={forceFetch} setNumItems={setNumItems} setForceFetch={setForceFetch} subject={subject} setSubject={setSubject} />}
    
      {activeTab === 'data' && <div><Data modalData={modalData} setModalData={setModalData} handleModalChange={handleModalChange}/></div>}
      {activeTab === 'sample-response' && <div><SampleResponse template={template} setTemplate={setTemplate}/></div>}
      {activeTab === 'sample' && <div><Sample template={template}/></div>}
      {activeTab === 'playground' && <div><Playground template={template}/></div>}
      {activeTab === 'inspiration' && <div><img src={template?.inspiration} alt="Inspiration" style={{ 
        height: 300
       }} /></div>}
    </>
  </div>
);
};

function Sample({template}) {
  if (!template || !template.preview) {
    return (
      <Typography variant="h6">No sample available</Typography>
    )
  }
  if (template.previews.length > 1) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'start',
        maxWidth: "100%",
        overflow: 'auto',
        margin: 20,
        boxShadow: "0px 0px 7px #dddddd"
      }}>
        {template.previews.map((preview, index) =>  (
          <img key={index} src={preview} alt={`${template.title} preview ${index + 1}`} style={{
            width: 200,
            height: 200,
            objectFit: 'contain',
          }} />
        ))}
      </div>
    )
  }
  return (
    <div>
      <img src={template.preview} alt="Sample" style={{ width: 'auto', height: 'auto' }} />
    </div>
  )
}


function Playground({template}) {
  if (!template || !template.preview) {
    return (
      <Typography variant="h6">No sample available</Typography>
    )
  }
  return (
    <div>
      <DesignEditor id={template.id + "-sample"} />
    </div>
  )
}

function Html({template, setTemplate, currentPage, setCurrentPage, id, templateImages, setTemplateImages, generateSample, loading, error, numItems, forceFetch, setNumItems, setForceFetch, subject, setSubject}) {

  const [showMoreSettings, setShowMoreSettings] = useState(false);

  if (!template) return;
  
  return (
    <div style={{ 
      flexDirection: 'row',
      display: 'flex',
      justifyContent: 'start',  
      alignItems: 'stretch',
      height: "100%"
      
    }}>
      <div style={{ 
        flexGrow: 1
      }}>
        <HtmlEditor 
          code={currentPage == "styles" ? template.styles : template.pages[currentPage].html}
          setCode={(code => {
            const updated = [...template.pages];
            if (currentPage == "styles") {
              setTemplate({
                ...template,
                styles: code
              });
            } else {
              updated[currentPage].html = code;
              setTemplate({
                ...template,
                pages: updated
              });
            }
          })}
        />
      </div>
      <div style={{
        width: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 20,
        padding: 20
      }}>
        <Pages template={template} setTemplate={setTemplate} currentPage={currentPage} setCurrentPage={(page) => setCurrentPage(page)} />
        <div>
          <ImagesUploader templateId={id} templateImages={templateImages} setTemplateImages={setTemplateImages} />
          
          <div style={{
            marginTop: 10
          }}>
            {!showMoreSettings && <IconButton style={{
              marginBottom: 10
            }} onClick={() => {
              setShowMoreSettings(true);
            }}>
              <MoreHorizIcon />
            </IconButton>}
            {showMoreSettings && (
              <div style={{
                marginBottom: 20
              }}>
                <div style={{
                  marginBottom: 20,
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 10,
                }}>
                  <TextField type="number" label="Items" value={numItems} onChange={(e) => setNumItems(e.target.value)} />
                  <Select value={forceFetch} onChange={(e) => setForceFetch(e.target.value)}>
                    <MenuItem value={true}>Force Fetch</MenuItem>
                    <MenuItem value={false}>Don't Force Fetch</MenuItem>
                  </Select>
                  
                </div>
                  <TextField label="Subject" fullWidth value={subject} onChange={(e) => setSubject(e.target.value)} size="small" />
              </div>
            )}

            
            <Box sx={{ display: 'flex' }}>
              <Button variant="contained" color="secondary" onClick={generateSample} disabled={loading || error} fullWidth>Generate Sample</Button>
              {loading && <CircularProgress />}
            </Box>
            {error && (
            <Alert severity={error?.startsWith('Error') ? 'error' : 'success'} sx={{ mt: 3 }}>
              {error}
            </Alert>
          )}
          </div>
        </div>
      </div>
      
  </div>
  )
}

function Pages({template, setTemplate, currentPage, setCurrentPage}) {
  if (!template) return;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      gap: 15
    }}>
      <Select size="small" fullWidth value={currentPage} onChange={(e) => {
        if (e.target.value === "styles") {
          setCurrentPage("styles");
        }
        else if (e.target.value === "add") {
          setTemplate({
            ...template,
            pages: [...template.pages, {html:'',config:null}]
          });
        } else {
          setCurrentPage(e.target.value)
        }
      }} style={{
        flexGrow: 1
      }}>
        {Array(template.pages.length).fill(0).map((_, index) => (
          <MenuItem key={index} value={index}>Page {index + 1}</MenuItem>
        ))}
        {template.styles && (<MenuItem value="styles">style.css</MenuItem>)}
        <MenuItem value="add">Add Page</MenuItem>
      </Select>
      <IconButton onClick={() => {
        setTemplate({
          ...template,
          pages: [...template.pages.slice(0, currentPage), ...template.pages.slice(currentPage + 1)]
        });
      }}>
        <Delete style={{
          color: "rgb(212, 118, 118)"
        }}/>
      </IconButton>
    </div>
  )
}

function Data({modalData, setShowModal, handleModalChange}) {
  return <Box style={{
    padding: 10,
    maxWidth: 600,
    textAlign: 'center',
    margin: 'auto'
  }}>
      <Typography variant="h6">Section Header</Typography>
      <TextareaAutosize
        minRows={2}
        style={{ width: '100%' }}
        value={modalData.sectionHeader.title}
        onChange={(e) => handleModalChange('sectionHeader', 'title', e.target.value)}
        placeholder="Title"
      />
      <TextareaAutosize
        minRows={2}
        style={{ width: '100%', marginTop: '10px' }}
        value={modalData.sectionHeader.body}
        onChange={(e) => handleModalChange('sectionHeader', 'body', e.target.value)}
        placeholder="Body"
      />
    
      <Typography variant="h6">Blocks</Typography>
      {modalData.blocks.map((block, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <TextareaAutosize
            minRows={2}
            style={{ width: '100%' }}
            value={block.title}
            onChange={(e) => handleModalChange('blocks', 'title', e.target.value, index)}
            placeholder={`Block ${index + 1} Title`}
          />
          <TextareaAutosize
            minRows={2}
            style={{ width: '100%', marginTop: '10px' }}
            value={block.body}
            onChange={(e) => handleModalChange('blocks', 'body', e.target.value, index)}
            placeholder={`Block ${index + 1} Body`}
          />
        </Box>
      ))}
   
      <Typography variant="h6">Footer</Typography>
      <TextareaAutosize
        minRows={2}
        style={{ width: '100%' }}
        value={modalData.footer.title}
        onChange={(e) => handleModalChange('footer', 'title', e.target.value)}
        placeholder="Footer Title"
      />
      <TextareaAutosize
        minRows={2}
        style={{ width: '100%', marginTop: '10px' }}
        value={modalData.footer.body}
        onChange={(e) => handleModalChange('footer', 'body', e.target.value)}
        placeholder="Footer Body"
      />
   
  </Box>
}
export default TemplateEditor;

